import { Typography, Box } from "@mui/material";

const Header = ({ title, subtitle }) => {
  return (
    <Box mb={2}>
      <Typography variant="h4" fontWeight="bold">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="subtitle1" color="textSecondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default Header;